import { AppLocale } from '@/domain/enums/appLocale';
import { en } from './en';
import { ro } from './ro';
import type { l10n } from './l10n';

export const translations: Record<AppLocale, l10n> = {
  en,
  ro,
};

/**
 * A single selectable language, as offered by the language selector.
 *
 * `name` is the exonym (the language's name in English, used for secondary
 * copy) and `nativeName` is the endonym (the language's name in itself), which
 * is the primary label a user scans. Neither is translated copy — they are the
 * languages' own names — so no l10n key backs them.
 *
 * Declaration order of `locales` below is the source order, NOT the display
 * order: consumers that want an alphabetical list use `useLanguageOptions`.
 */
export interface LocaleOption {
  code: AppLocale;
  name: string;
  nativeName: string;
}

export const locales: LocaleOption[] = [
  { code: AppLocale.EN, name: 'English', nativeName: 'English' },
  { code: AppLocale.RO, name: 'Romanian', nativeName: 'Română' },
];
